module.exports = __webpack_public_path__ + "static/kenku-1-e84121320dbccdef32a52be0f76c5baa.jpg";